// ClientForm.js - Komponenten für die verschiedenen Formularschritte
import React from 'react';

/**
 * Step 1: Allgemeine Client-Informationen
 */
export const ClientFormStep1 = ({ clientData, onChange }) => {
  return (
    <div>
      <div className="mb-4">
        <label className="block mb-2">Kundenname</label>
        <input
          type="text"
          name="name"
          value={clientData.name}
          onChange={onChange}
          className="w-full p-2 border border-gray-300 rounded-md"
        />
      </div>
      <div className="mb-4">
        <label className="block mb-2">Steuernummer</label>
        <input
          type="text"
          name="taxNumber"
          value={clientData.taxNumber}
          onChange={onChange}
          className="w-full p-2 border border-gray-300 rounded-md"
        />
      </div>
      <div className="mb-4">
        <label className="block mb-2">USt-IdNr</label>
        <input
          type="text"
          name="vatRegistrationId"
          value={clientData.vatRegistrationId}
          onChange={onChange}
          className="w-full p-2 border border-gray-300 rounded-md"
        />
      </div>
      <div className="mb-4">
        <label className="block mb-2">Steuerfreie Rechnungen erlauben</label>
        <input
          type="checkbox"
          name="allowTaxFreeInvoices"
          checked={clientData.allowTaxFreeInvoices}
          onChange={(e) => onChange({ target: { name: 'allowTaxFreeInvoices', value: e.target.checked }})}
          className="mr-2"
        />
      </div>
    </div>
  );
};

/**
 * Step 2: Kontaktpersonen
 */
export const ClientFormStep2 = ({ contactPersons, onContactPersonChange }) => {
  return (
    <div className="mb-4">
      <label className="block mb-2">Kontaktperson</label>
      {contactPersons.map((person, index) => (
        <div key={index} className="mb-2">
          <div className="flex space-x-2">
            <input
              type="text"
              name="salutation"
              value={person.salutation}
              placeholder="Anrede"
              onChange={(e) => onContactPersonChange(e, index)}
              className="w-1/4 p-2 border border-gray-300 rounded-md"
            />
            <input
              type="text"
              name="firstName"
              value={person.firstName}
              placeholder="Vorname"
              onChange={(e) => onContactPersonChange(e, index)}
              className="w-1/2 p-2 border border-gray-300 rounded-md"
            />
            <input
              type="text"
              name="lastName"
              value={person.lastName}
              placeholder="Nachname"
              onChange={(e) => onContactPersonChange(e, index)}
              className="w-1/2 p-2 border border-gray-300 rounded-md"
            />
          </div>
          <input
            type="email"
            name="emailAddress"
            value={person.emailAddress}
            placeholder="E-Mail-Adresse"
            onChange={(e) => onContactPersonChange(e, index)}
            className="w-full mt-2 p-2 border border-gray-300 rounded-md"
          />
          <input
            type="text"
            name="phoneNumber"
            value={person.phoneNumber}
            placeholder="Telefonnummer"
            onChange={(e) => onContactPersonChange(e, index)}
            className="w-full mt-2 p-2 border border-gray-300 rounded-md"
          />
        </div>
      ))}
    </div>
  );
};

/**
 * Step 3: Adressen
 */
export const ClientFormStep3 = ({ addresses, onAddressChange }) => {
  return (
    <div>
      <div className="mb-4">
        <label className="block mb-2">Rechnungsadresse</label>
        {addresses.billing.map((address, index) => (
          <div key={index} className="mb-2">
            <input
              type="text"
              name="supplement"
              value={address.supplement}
              placeholder="Adresszusatz"
              onChange={(e) => onAddressChange(e, 'billing', index)}
              className="w-full p-2 border border-gray-300 rounded-md"
            />
            <input
              type="text"
              name="street"
              value={address.street}
              placeholder="Straße"
              onChange={(e) => onAddressChange(e, 'billing', index)}
              className="w-full mt-2 p-2 border border-gray-300 rounded-md"
            />
            <input
              type="text"
              name="zip"
              value={address.zip}
              placeholder="PLZ"
              onChange={(e) => onAddressChange(e, 'billing', index)}
              className="w-full mt-2 p-2 border border-gray-300 rounded-md"
            />
            <input
              type="text"
              name="city"
              value={address.city}
              placeholder="Stadt"
              onChange={(e) => onAddressChange(e, 'billing', index)}
              className="w-full mt-2 p-2 border border-gray-300 rounded-md"
            />
          </div>
        ))}
      </div>
      <div className="mb-4">
        <label className="block mb-2">Lieferadresse</label>
        {addresses.shipping.map((address, index) => (
          <div key={index} className="mb-2">
            <input
              type="text"
              name="supplement"
              value={address.supplement}
              placeholder="Adresszusatz"
              onChange={(e) => onAddressChange(e, 'shipping', index)}
              className="w-full p-2 border border-gray-300 rounded-md"
            />
            <input
              type="text"
              name="street"
              value={address.street}
              placeholder="Straße"
              onChange={(e) => onAddressChange(e, 'shipping', index)}
              className="w-full mt-2 p-2 border border-gray-300 rounded-md"
            />
            <input
              type="text"
              name="zip"
              value={address.zip}
              placeholder="PLZ"
              onChange={(e) => onAddressChange(e, 'shipping', index)}
              className="w-full mt-2 p-2 border border-gray-300 rounded-md"
            />
            <input
              type="text"
              name="city"
              value={address.city}
              placeholder="Stadt"
              onChange={(e) => onAddressChange(e, 'shipping', index)}
              className="w-full mt-2 p-2 border border-gray-300 rounded-md"
            />
          </div>
        ))}
      </div>
    </div>
  );
};

/**
 * Step 4: Kontaktdaten und Notiz
 */
export const ClientFormStep4 = ({ emailAddresses, phoneNumbers, note, onEmailChange, onPhoneChange, onNoteChange }) => {
  return (
    <div className="h-96 overflow-y-auto">
      <div className="mb-4">
        <label className="block mb-2">E-Mail-Adressen</label>
        {Object.keys(emailAddresses).map((type) => (
          <div key={type} className="mb-2">
            <label className="block mb-1">{type.charAt(0).toUpperCase() + type.slice(1)}</label>
            {emailAddresses[type].map((email, index) => (
              <input
                key={index}
                type="email"
                value={email}
                placeholder={`${type} E-Mail`}
                onChange={(e) => onEmailChange(e, type, index)}
                className="w-full mt-2 p-2 border border-gray-300 rounded-md"
              />
            ))}
          </div>
        ))}
      </div>
      <div className="mb-4">
        <label className="block mb-2">Telefonnummern</label>
        {Object.keys(phoneNumbers).map((type) => (
          <div key={type} className="mb-2">
            <label className="block mb-1">{type.charAt(0).toUpperCase() + type.slice(1)}</label>
            {phoneNumbers[type].map((phone, index) => (
              <input
                key={index}
                type="text"
                value={phone}
                placeholder={`${type} Telefonnummer`}
                onChange={(e) => onPhoneChange(e, type, index)}
                className="w-full mt-2 p-2 border border-gray-300 rounded-md"
              />
            ))}
          </div>
        ))}
      </div>
      <div className="mb-4">
        <label className="block mb-2">Notiz</label>
        <textarea
          name="note"
          value={note}
          onChange={onNoteChange}
          className="w-full p-2 border border-gray-300 rounded-md"
        ></textarea>
      </div>
    </div>
  );
};
